<script>
import ListViewTemplate from './ListViewTemplate'

import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import feedbackMixin from '../mixins/feedback'
import listViewMixin from '../mixins/list-view'
import exportFileMixin from "../mixins/export-file";

Vue.use(VueAxios, axios);

export default {
	name: 'Jobs',
	mixins: [feedbackMixin, listViewMixin, exportFileMixin],
	extends: ListViewTemplate,
	data() {
		return {
			primaryKey: '__PKJobID',
			columns: [
				{
					name: '__PKJobID',
					displayName: 'ID',
					sort: 0
				},
				{
					name: 'Company Name',
					displayName: 'Company Name',
					sort: 0
				},
				{
					name: 'Registration::State',
					displayName: 'State',
					sort: 0
				},
				{
					name: 'Job Name',
					displayName: 'Name',
					sort: 0
				},
				{
					name: 'Activity',
					displayName: 'Activity',
					sort: 0
				},
				{
					name: 'Date Transfer',
					displayName: 'Transferred',
					sort: 0
				},
				{
					name: 'Date Destroyed',
					displayName: 'Destroyed',
					sort: 0
				},
				{
					name: 'Date Job Initiated',
					displayName: 'Initiated',
					sort: 0
				},
				{
					name: 'Date Filed',
					displayName: 'Completed',
					sort: 0
				},
				{
					name: 'Locked Job',
					displayName: 'Locked',
					sort: 0,
					locked: true
				},
				{
					name: 'Facility Transported to',
					displayName: 'Facility',
					sort: 0
				},
				{
					name: 'Transporter',
					displayName: 'Transporter',
					sort: 0
				},
				{
					name: 'Job_Agent_fkAgentTransferWitness1::FullName',
					displayName: 'Witness 1',
					sort: 0
				},
				{
					name: 'Job_Agent_fkAgentDestructionWitness2::FullName',
					displayName: 'Witness 2',
					sort: 0
				},
				{
					name: 'Date Created',
					displayName: 'Created',
					sort: 0
				},
				{
					name: 'Created By',
					displayName: 'By',
					searchName: 'Created By',
					sort: 0
				}

			],
			fields: [
				{
					key: 'lockedField',
					label: ''
				},
				{
					key: '__PKJobID',
					label: 'ID',
					sortable: true,
					stickyColumn: true
				},
				{
					key: 'Company Name',
					label: 'Company Name',
					sortable: true
				},
				{
					key: 'Registration::State',
					label: 'State',
					sortable: true
				},
				{
					key: 'Job Name',
					label: 'Name',
					sortable: true
				},
				{
					key: 'Activity',
					label: 'Activity',
					sortable: true
				},
				{
					key: 'Date Transfer',
					date: true,
					label: 'Transferred',
					sortable: true
				},
				{
					key: 'Date Destroyed',
					date: true,
					label: 'Destroyed',
					sortable: true
				},
				{
					key: 'Date Job Initiated',
					date: true,
					label: 'Initiated',
					sortable: true
				},
				{
					key: 'Date Filed',
					date: true,
					label: 'Completed',
					sortable: true
				},
				{
					key: 'Facility Transported To',
					label: 'Facility',
					sortable: true
				},
				{
					key: 'Transporter',
					label: 'Transporter',
					sortable: true
				},
				{
					key: 'Job_Agent_fkAgentTransferWitness1::FullName',
					label: 'Witness 1',
					sortable: true
				},
				{
					key: 'Job_Agent_fkAgentDestructionWitness2::FullName',
					label: 'Witness 2',
					sortable: true
				},
				{
					key: 'Date Created',
					date: true,
					label: 'Created',
					sortable: true
				},
				{
					key: 'Created By',
					label: 'By',
					searchName: 'Created By',
					sortable: true
				}

			],
			headerTitle: 'Jobs',
			restEntity: 'jobs',
			restDetailEntity: 'job-view',
			leftmostColumn: 'cell(__PKJobID)',
			lockedColumn: 'Locked Job'
		}
	},
}
</script>
<style scoped>
</style>